module.exports = __webpack_public_path__ + "img/question.57d61bbc.svg";